import React from "react";
import HeroSection from "../components/sections/HeroSection";
import WhyUsSection from "../components/sections/WhyUsSection";
import ShowcaseSection from "../components/sections/ShowcaseSection";
import ServicesSection from "../components/sections/ServicesSection";
import CTASection from "../components/sections/CTASection";
import ContactSection from "../components/sections/ContactSection";
import useDocumentMeta from "../hooks/useDocumentMeta";
import { COMPANY } from "../data/constants";

export default function Home() {
  useDocumentMeta({
    title: `${COMPANY.name} — ${COMPANY.slogan}`,
    description: COMPANY.tagline,
  });

  return (
    <>
      <HeroSection />
      <WhyUsSection />
      <ShowcaseSection />
      <ServicesSection />
      <CTASection />
      <ContactSection />
    </>
  );
}
